import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Loans = () => {
  return (
    <div className="container-fluid p-5">
      <div className="row">
        <div className="col-md-12 text-center">
          <h1 className="mb-4 text-primary">All About Loans</h1>
          <p className="lead">
            Loans help you meet your financial goals—whether it’s buying a home, funding education, or handling emergencies.
          </p>
          <img 
            src="./loan.jpg" 
            alt="Loans" 
            className="img-fluid rounded shadow mt-3 mb-5"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h3 className="text-success">Types of Loans</h3>
          <ul className="list-group shadow">
            <li className="list-group-item">Personal Loan</li>
            <li className="list-group-item">Home Loan</li>
            <li className="list-group-item">Car Loan</li>
            <li className="list-group-item">Education Loan</li>
            <li className="list-group-item">Business Loan</li>
            <li className="list-group-item">Digital Business Loan</li>
            <li className="list-group-item">Loan Against Bond</li>
            <li className="list-group-item">Education Loan Against Bond</li>
          </ul>
        </div>

        <div className="col-md-6">
          <h3 className="text-success">Benefits of Loans</h3>
          <ul className="list-group shadow">
            <li className="list-group-item">Fulfills financial needs</li>
            <li className="list-group-item">Builds credit history</li>
            <li className="list-group-item">Emergency support</li>
            <li className="list-group-item">Flexible terms</li>
          </ul>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-12">
          <h3 className="text-info">Additional Loan Types</h3>
          <div className="card shadow mb-3">
            <div className="card-body">
              <h5 className="card-title">Digital Business Loan</h5>
              <p className="card-text">
                Digital Business Loans are tailored for small and medium enterprises to streamline funding needs with minimal paperwork and fast approval.
              </p>
            </div>
          </div>
          <div className="card shadow mb-3">
            <div className="card-body">
              <h5 className="card-title">Loan Against Bond</h5>
              <p className="card-text">
                A Loan Against Bond allows you to leverage your bonds as collateral to secure funds while continuing to earn returns on your investment.
              </p>
            </div>
          </div>
          <div className="card shadow">
            <div className="card-body">
              <h5 className="card-title">Education Loan Against Bond</h5>
              <p className="card-text">
                This specialized loan lets students and their families utilize bonds as collateral to finance education, ensuring minimal financial burden.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-12">
          <h3 className="text-info">Latest Loan News</h3>
          <div className="card shadow mb-3">
            <div className="card-body">
              <h5 className="card-title">Interest Rates Expected to Rise</h5>
              <p className="card-text">Experts predict an increase in interest rates in the upcoming quarter due to inflation trends. Borrowers are advised to lock in rates now.</p>
            </div>
          </div>
          <div className="card shadow">
            <div className="card-body">
              <h5 className="card-title">Government Introduces Subsidized Education Loan Scheme</h5>
              <p className="card-text">Students can now avail loans at 4% interest rate under the new initiative. Applications open from next month.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-12">
          <h3 className="text-warning">Loan Application Process</h3>
          <ol className="list-group list-group-numbered shadow">
            <li className="list-group-item">Choose your loan type</li>
            <li className="list-group-item">Check your eligibility</li>
            <li className="list-group-item">Complete the application</li>
            <li className="list-group-item">Upload documents</li>
            <li className="list-group-item">Wait for approval</li>
            <li className="list-group-item">Receive funds</li>
          </ol>
        </div>
      </div>

      <div className="row mt-5 mb-5">
        <div className="col-md-12">
          <h3 className="text-danger">Things to Consider</h3>
          <ul className="list-group shadow">
            <li className="list-group-item">Interest rates</li>
            <li className="list-group-item">Tenure & EMIs</li>
            <li className="list-group-item">Processing fees</li>
            <li className="list-group-item">Hidden charges</li>
            <li className="list-group-item">Foreclosure options</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Loans;
